import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import RecommendedEvent from "../Component/RecommendedEvent";
import FeaturedEvent from "../Component/FeaturedEvent";
import PopularCity from "../Component/PopularCity";
import Footer from "../Component/Footer";
import RecommendedConference from "../Component/RecommendedConference";
import { Helmet } from "react-helmet";

import logo from "../Component/img/logo.png";

import { ChevronsRight, ChevronLeft } from "react-feather";
import AdSenseAutoRelaxed from "../AdSenseAutoRelaxed";
import IndustryCompo from "../Component/IndustryCompo";
import PopularCountry from "../Component/PopularCountry";

// Custom Previous Arrow
const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{ ...arrowStyles, left: "0px" }}
    >
      {/* <FontAwesomeIcon icon={faChevronLeft} /> */}
    </div>
  );
};

// Custom Next Arrow
const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{ ...arrowStyles, right: "0px" }}
    >
      <ChevronsRight />
    </div>
  );
};

// Styles for the arrows
const arrowStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#0006",
  color: "#fff",
  borderRadius: "5px",
  padding: "40px 16px",
  cursor: "pointer",
  zIndex: 2,
};

const Home = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [location, setLocation] = useState(null); // State for storing location info

  // Fetch banners from the API with a 4-second delay
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/fetch-banners`);
        if (response.data.success) {
          setBanners(response.data.data);
        } else {
          setError("No banners found.");
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching banners:", err);
        setError("Failed to fetch banners.");
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  // Get the user's geolocation (country, state, city) using Nominatim (OpenStreetMap)
  useEffect(() => {
    const fetchGeoLocation = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            console.log("Latitude:", latitude, "Longitude:", longitude);

            // Use Nominatim API for reverse geocoding (without API key)
            try {
              const geoResponse = await axios.get(
                `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
              );
              if (geoResponse.data.address) {
                const { country, state, city } = geoResponse.data.address;
                setLocation({ country, state, city });
                console.log("Location Data:", country, state, city);
              } else {
                console.error("No location found.");
              }
            } catch (err) {
              console.error("Error fetching location:", err);
            }
          },
          (error) => {
            console.error("Error fetching geolocation:", error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    };

    fetchGeoLocation();
  }, []);

  // Slider settings with custom next and previous buttons
  // const settings = {
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 3000,
  //   nextArrow: <NextArrow />,
  //   prevArrow: <PrevArrow />,
  // };
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true, // Enables the center mode
    centerPadding: "0", // Removes the gap between slides
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <>
      <Helmet>
        <title>
          Evventoz : Discover &amp; Promote Trade Shows, Conferences &amp;
          Events.
        </title>
        <meta
          name="description"
          content="Evventoz is an online events aggregator Platform, allowing users to 
          add Events, Exhibitions, Conferences shows and allowing discovery events based on location. 
          1 Million+ Members associated."
        />
        <meta
          name="keywords"
          content="events, conferences, online events, recommended events, popular cities"
        />
        <meta
          property="og:title"
          content="Evventoz : Discover &amp; Promote Trade Shows, Conferences &amp; Events."
        />
        <meta
          property="og:description"
          content="Evventoz is an online events aggregator Platform, allowing users 
          to add Events, Exhibitions, Conferences shows and allowing discovery events 
          based on location. 1 Million+ Members associated."
        />
        <meta property="og:image" content="https://evventoz.com/logo2.png" />
        <meta property="og:url" content="https://www.evventoz.com" />
        <link rel="canonical" href="https://www.evventoz.com" />
        {/* Add sitemap or any other links if required */}
      </Helmet>

      <NavbarVisitor />

      {/* Banner Section */}
      <div className="banner-slider">
        {loading ? (
          <div className="placeholder-glow">
            <div
              className="placeholder"
              style={{ height: "200px", width: "100%" }}
            ></div>{" "}
            {/* Banner placeholder */}
          </div>
        ) : (
          <Slider {...settings}>
            {banners.map((banner) => (
              <div key={banner.id}>
                <a href={`${banner.url_link}`}>
                  <img
                    src={`${IMAGE_URL}banner/${banner.banner_image}`} // Use the fetched banner image
                    alt={banner.url_link}
                    className="mjsa1"
                    loading="lazy" // Lazy loading for images
                  />
                </a>
              </div>
            ))}
          </Slider>
        )}
      </div>

      {/* Rest of the Content */}
      <div className="container  clju mt-2">
        <div>
          <IndustryCompo />
        </div>

        <RecommendedEvent />

        <RecommendedConference />
        <FeaturedEvent />

        <PopularCountry />

        {/* <PopularCity /> */}
        {/* <AdSenseAutoRelaxed/> */}
        {/* <PopularState /> */}
      </div>
      <Footer />
    </>
  );
};

export default Home;
